// src/services/anomalyApiService.js
// --- UPDATE ---------------------------------------------------------------------
// Uses the shared axios instance (services/api): the auth header comes from its interceptor,
// a 401 clears the session like every other call, and requests without a token no longer send
// "Authorization: Bearer null". Same functions, same return values.
// subscribeToAnomalies(callback) added for live views ('critical_anomaly' + 'ai_activity'
// entries of kind 'anomaly').
// --- END UPDATE ------------------------------------------------------------------
import api from './api';
import webSocketService from './websocketService';

export const anomalyApiService = {
    getRecentAnomalies: async (params = { limit: 50, offset: 0 }) => {
        const response = await api.get('/anomalies', { params });
        return response.data;
    },

    getStats: async (hours = 24) => {
        const response = await api.get('/anomalies/stats', { params: { hours } });
        return response.data;
    },

    createAiRule: async (rulePayload) => {
        const response = await api.post('/anomalies/rules/ai-suggested', rulePayload);
        return response.data;
    },

    exportAnomaliesCsv: () => {
        return api.get('/anomalies/export', { responseType: 'blob' });
    },

    // --- UPDATE ---
    /**
     * Live anomalies. callback(payload, source) where source is 'critical_anomaly' or 'ai_activity'.
     * @returns {function} unsubscribe
     */
    subscribeToAnomalies: (callback) => {
        const onCritical = (msg) => callback(msg?.payload ?? msg, 'critical_anomaly');
        const onActivity = (msg) => { const p = msg?.payload ?? msg; if (p?.kind === 'anomaly') callback(p, 'ai_activity'); };
        webSocketService.subscribe('critical_anomaly', onCritical);
        webSocketService.subscribe('ai_activity', onActivity);
        return () => {
            webSocketService.unsubscribe('critical_anomaly', onCritical);
            webSocketService.unsubscribe('ai_activity', onActivity);
        };
    },
    // --- END UPDATE ---
};
